import "core-js/modules/es.array.map";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getGoodsspuList, deleteGoodsspu } from '@/api/bairun/bianlidian'; //  此处请自行替换地址

import AddSPUDialog from '@/view/bianlidianManage/goodsspu/add';
import { formatTimeToStr } from '@/utils/date';
import infoList from '@/mixins/infoList';
import { mapGetters } from "vuex";

var _this;

export default {
  name: 'BianlidianGoodsSpu',
  components: {
    AddSPUDialog: AddSPUDialog
  },
  computed: _objectSpread({}, mapGetters('user', ['userInfo', 'token'])),
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool != null) {
        return bool ? '是' : '否';
      } else {
        return '';
      }
    }
  },
  mixins: [infoList],
  data: function data() {
    return {
      listApi: getGoodsspuList,
      addSPUDialogFormData: {
        type: '',
        dialogVisible: false,
        formData: {},
        configTicketAble: []
      }
    };
  },
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var configTicketAble;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // 使用keepalive的页面,重新展示不会调用
              console.log(' created');
              _context.next = 3;
              return _this2.getDict('shopTicketCategoryNo');

            case 3:
              configTicketAble = _context.sent;
              _this2.addSPUDialogFormData.configTicketAble = (configTicketAble || []).map(function (item) {
                return item.value;
              });
              _context.next = 7;
              return _this.getTableData();

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    // 条件搜索前端看此方法
    onSubmit: function onSubmit() {
      this.page = 1;
      this.pageSize = 10;
      this.getTableData();
    },
    onReset: function onReset() {
      this.searchInfo = {};
      this.onSubmit();
    },
    // 新增或修改组件回调
    handleSPUDialogCallback: function handleSPUDialogCallback(res) {
      this.getTableData();
    },
    // 关闭组件
    handelSPUDialogClose: function handelSPUDialogClose() {
      this.addSPUDialogFormData.dialogVisible = false;
      this.addSPUDialogFormData = Object.assign(this.addSPUDialogFormData, {
        type: '',
        dialogVisible: false,
        formData: {}
      });
    },
    onAdd: function onAdd() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var that;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                that = _this3;
                that.addSPUDialogFormData.type = 'add';
                that.addSPUDialogFormData.dialogVisible = true;
                that.addSPUDialogFormData.formData = {};

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    onUpdate: function onUpdate(row) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var that;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                that = _this4;
                that.addSPUDialogFormData.type = 'update';
                that.addSPUDialogFormData.dialogVisible = true;
                that.addSPUDialogFormData.formData = row;

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    onDel: function onDel(row) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var that;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                that = _this5;
                that.$confirm('确定要删除吗？', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(function () {
                  deleteGoodsspu({
                    'spuNo': row.spuNo
                  }).then(function (res) {
                    if (res.code == 0) {
                      that.$message({
                        type: 'success',
                        message: res.msg
                      });
                      that.getTableData();
                    }
                  }, function (err) {});
                }).catch(function (err) {});

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    }
  }
};